import PageableRq from '../common/PageableRq';

export default class PassReviewPostListGetRq extends PageableRq {
  keyword: string;

  constructor(rq: PassReviewPostListGetRq) {
    super(rq);
    this.keyword = rq.keyword;
  }
}
